"use strict";

var formValidation = require("../components/formValidation");
var checkboxesGroupValidation = require("../components/checkboxesGroupValidation");
var fieldRequirements = require("../components/fieldRequirements");
var initializeCheckboxAccessibility = require("../components/checkboxAccessibility");
var passwordShow = require("../components/passwordShow");
var googleRecaptcha = require("../googleRecaptcha");
var recaptchaErrorNotification = require("../components/recaptchaErrorNotification");
const newsletterValidation = require("../components/newsletterValidation");
const setClearButtonPosition = require("../components/setClearButtonPosition");

module.exports = {
    fieldRequirements: fieldRequirements(),
    initializeCheckboxAccessibility: initializeCheckboxAccessibility(".m-newsletter"),
    verifyEmailAddress: function verifyEmailAddress() {
        $("form.newsletter #newsletter_email").on("blur", function () {
            var form = $("form.newsletter");
            var url = form.attr("data-email-verification-url");
            if (!url || url.length === 0) {
                return;
            }

            function postVerify(extraData) {
                var data = form.serialize();
                if (extraData) {
                    data += "&" + $.param(extraData);
                }
                $.ajax({
                    url: url,
                    type: "post",
                    data: data,
                    success: function (responseData) {
                        var formGroup = form.find(".newsletter-password");
                        var formHint = form.find(".newsletter-password-hint");
                        var forgotPasswordLink = form.find(".forgot-password");

                        if (responseData.profileExists) {
                            formGroup.removeClass("d-none").addClass("required");
                            formGroup.find("input").attr("required", "required").attr("aria-required", true);
                            formHint.removeClass("d-none");
                            forgotPasswordLink.removeClass("d-none");
                        } else {
                            formGroup.addClass("d-none").removeClass("required");
                            formGroup.find("input").removeAttr("required").removeAttr("aria-required");
                            formHint.addClass("d-none");
                            forgotPasswordLink.addClass("d-none");
                        }
                    }
                });
            }

            var v3Enabled = $("#google-recaptcha-main").data("google-recaptchav3-enabled");
            var v3SiteKey = $("#google-recaptcha-main").data("google-recaptchav3-key");
            if (v3Enabled && typeof grecaptcha !== "undefined" && v3SiteKey) {
                grecaptcha.ready(function () {
                    grecaptcha.execute(v3SiteKey, {
                        action: "newsletter_verify_email"
                    }).then(function (token) {
                        postVerify({ "g-recaptcha-response": token });
                    }, function () {
                        postVerify();
                    });
                });
            } else {
                postVerify();
            }
        });
    },

    submitNewsletter: function () {
        $("form.newsletter").submit(function (e) {
            e.preventDefault();
            var form = $(this);
            var firstNameElement = form.find("#newsletter_firstName");
            var lastNameElement = form.find("#newsletter_lastName");
            var jpFirstNameElement = form.find("#newsletter_katakanaFirstName");
            var jpLastNameElement = form.find("#newsletter_katakanaLastName");
            var firstName = firstNameElement.val().trim();
            var lastName = lastNameElement.val().trim();
            var isFirstNameValid = newsletterValidation.isValidName(firstName);
            var isLastNameValid = newsletterValidation.isValidName(lastName);

            var isKataKanaInvalid = false;
            var jpFirstName, jpLastName, isJPFirstNameValid, isJPLastNameValid;
            if (jpFirstNameElement && jpFirstNameElement.length > 0 && jpLastNameElement && jpLastNameElement.length > 0) {
                jpFirstName = jpFirstNameElement.val().trim();
                jpLastName = jpLastNameElement.val().trim();
                isJPFirstNameValid = newsletterValidation.isValidKatakanaName(jpFirstName);
                isJPLastNameValid = newsletterValidation.isValidKatakanaName(jpLastName);
                isFirstNameValid = newsletterValidation.isValidKanjiName(firstName);
                isLastNameValid = newsletterValidation.isValidKanjiName(lastName);
                isKataKanaInvalid = !isJPFirstNameValid || !isJPLastNameValid;
            }

            if (!isFirstNameValid || !isLastNameValid || isKataKanaInvalid) {
                var invalidErrorMessage = $("#invalid-input-error-message").val() || "Invalid input provided.";

                // Determine which field is invalid and show feedback
                if (!isFirstNameValid) {
                    firstNameElement.addClass("is-invalid");
                    firstNameElement.siblings(".invalid-feedback").text(invalidErrorMessage);
                    setClearButtonPosition(firstNameElement);
                }
                if (!isLastNameValid) {
                    lastNameElement.addClass("is-invalid");
                    lastNameElement.siblings(".invalid-feedback").text(invalidErrorMessage);
                    setClearButtonPosition(lastNameElement);
                }
                if (isKataKanaInvalid) {
                    if (!isJPFirstNameValid) {
                        jpFirstNameElement.addClass("is-invalid");
                        jpFirstNameElement.siblings(".invalid-feedback").text(invalidErrorMessage);
                        setClearButtonPosition(jpFirstNameElement);
                    }
                    if (!isJPLastNameValid) {
                        jpLastNameElement.addClass("is-invalid");
                        jpLastNameElement.siblings(".invalid-feedback").text(invalidErrorMessage);
                        setClearButtonPosition(jpLastNameElement);
                    }
                }

                
                return;
            }

            // Only run checkbox validation if input is valid
            var checkboxValidation = checkboxesGroupValidation();
            if (!checkboxValidation) {
                var url = form.attr("action");
                form.spinner().start();
                googleRecaptcha.getRecaptchaResponse().then(function () {
                    $.ajax({
                        url: url,
                        type: "post",
                        data: form.serialize(),
                        success: function (data) {
                            form.spinner().stop();
                            if (!data.success) {
                                formValidation(form, data);
                            } else {
                                if ($("#form-sport-preferences-error").html().length == 0) {
                                    $(".js-newsletter-confirmation").html(data.renderingTemplate);
                                }
                            }
                            $(window).scrollTop(0);
                        },
                        error: function () {
                            form.spinner().stop();
                        }
                    });
                }).catch(function () {
                    form.spinner().stop();
                    var errorMessageText = $("#google-recaptcha-main").data("error-register");
                    recaptchaErrorNotification($(".m-newsletter__form-container").find(".error-newsletter-recaptcha"), errorMessageText);
                });
            }
        });
    },
    passwordShow: passwordShow()
};
